<template>
    <div class="container">
        <legend>お問い合わせ</legend>
        <div class="form-group contact-forms" v-if="step == 0">
            <div class="row" v-if="!$store.state.user">
                <div class="col-md-3">メールアドレス</div>
                <div class="col-md-9">
                    <input type="email" v-model="contact.email" class="form-control" :class="{'is-invalid': error.email}" placeholder="返信用メールアドレス">
                    <div class="invalid-feedback">
                        メールアドレスが入力されていません。
                    </div>
                </div>
            </div>
            <div class="row" v-if="!$store.state.user">
                <div class="col-md-3">お名前</div>
                <div class="col-md-9">
                    <input type="text" v-model="contact.name" class="form-control" :class="{'is-invalid': error.name}" placeholder="お名前">
                    <div class="invalid-feedback">
                        お名前が入力されていません。
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">お問い合わせ項目</div>
                <div class="col-md-9">
                    <select class="form-control" v-model="contact.subject" :class="{'is-invalid': error.subject}">
                        <option :value="null">選択してください</option>
                        <option v-for="(v, i) in SUBJECTS" :value="v" :key="i">{{v}}</option>
                    </select>
                    <div class="invalid-feedback">
                        お問い合わせ項目を選択してください。
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">お問い合わせ内容</div>
                <div class="col-md-9">
                    <div class="text-pane"
                        :class="{'is-invalid': error.topic}">
                        <div class="text-pane-dummy">{{contact.topic + '\u200b'}}</div>
                        <textarea class="text-pane-editor"
                            v-model="contact.topic"
                            placeholder="お問い合わせ内容"></textarea>
                    </div>
                    <div class="invalid-feedback">
                        お問い合わせ内容を入力してください。
                    </div>
                </div>
            </div>
            <div class="text-center">
                <button type="button" class="btn btn-outline-primary" @click="confirm()">
                    <i class="fas fa-check-circle"></i>
                    確認
                </button>
            </div>
        </div>
        <div class="form-group contact-forms" v-else-if="step == 1">
            <div class="row" v-if="!$store.state.user">
                <div class="col-md-3">メールアドレス</div>
                <div class="col-md-9 confirm-text">
                    {{contact.email}}
                </div>
            </div>
            <div class="row" v-if="!$store.state.user">
                <div class="col-md-3">お名前</div>
                <div class="col-md-9 confirm-text">
                    {{contact.name}}
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">お問い合わせ項目</div>
                <div class="col-md-9 confirm-text">
                    {{contact.subject}}
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">お問い合わせ内容</div>
                <div class="col-md-9 confirm-text" v-html="$filters.wrap(contact.topic)">
                </div>
            </div>
            <div class="text-center">
                <button type="button" class="btn btn-outline-secondary" @click="step = 0">
                    <i class="fas fa-angle-left"></i>
                    戻る
                </button>
                <button type="button" class="btn btn-outline-primary" @click="send()" :disabled="sending">
                    <i class="fas fa-circle-notch fa-spin" v-if="sending"></i>
                    <i class="fas fa-paper-plane" v-else></i>
                    送信
                </button>
            </div>
        </div>
        <div class="form-group contact-forms" v-else-if="step == 2">
            <div class="thanks">
                お問い合わせありがとうございます。<br>
                返信が必要なお問い合わせについては、内容を確認の上、返信させていただきます。<br>
            </div>
            <div class="text-center">
                <router-link to="/" class="btn btn-outline-secondary w-50" @click="clear()">
                    <i class="fas fa-angle-left"></i>
                    トップに戻る
                </router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contact-forms {
    max-width: 640px;
    margin: 1rem auto;
}
.row {
    margin-bottom: 1rem;
}
.confirm-text {
    background-color: #eee;
    padding: .5rem 1rem;
}
.thanks {
    margin: 3rem 0;
    padding: 3rem 1rem;
    text-align: center;
    background-color: #eee;
}

.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0px;
    border-radius: 4px;
    margin: 0 auto .5rem;
    .text-pane-dummy {
        overflow: hidden;
        font-size: 1rem;
        line-height: 2rem;
        box-sizing: border-box;
        padding: .5rem 1rem;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 1rem;
        line-height: 2rem;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: .5rem 1rem;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
</style>

<script>
export default {
    head: {
        title() {
            return {
                inner: "お問い合わせ",
                separator: "|",
                complement: "貸し本棚"
            }
        },
        link() {
            return [
                { rel: "canonical", href: location.origin + location.pathname, id: "canonical" },
            ]
        }
    },
    data() {
        return {
            SUBJECTS: [
                "ユーザ登録・ログイン・アカウント情報について",
                "利用方法・サービス全般について",
                "不具合・障害について",
                "迷惑行為・ガイドライン違反について",
                "その他のお問い合わせ"
            ],
            contact: {
                subject: null,
                topic: null,
                email: null,
                name: null,
            },
            error: {
                subject: false,
                topic: false,
                email: false,
                name: false,
            },
            step: 0,
            sending: false,
        }
    },
    methods: {
        send() {
            this.sending = true;
            axios.post("/contact/send", this.contact).then(res => {
                this.step = 2;
                this.sending = false;
                alert.msg(res.data);
            }).catch(err => {
                alert.err(err.response);
            });
        },
        confirm() {
            // バリデーション
            this.error = {
                subject: false,
                topic: false,
                email: false,
                name: false,
            };
            let step = 1;
            if (!this.$store.state.user) {
                if (!this.contact.email) {
                    this.error.email = true;
                    step = 0;
                }
                if (!this.contact.name) {
                    this.error.name = true;
                    step = 0;
                }
            }
            if (!this.contact.subject) {
                this.error.subject = true;
                step = 0;
            }
            if (!this.contact.topic) {
                this.error.topic = true;
                step = 0;
            }
            this.step = step;
        },
        clear() {
            this.contact = {
                subject: null,
                topic: null,
                email: null,
                name: null,
            };
            this.step = 0;
        }
    },
    mounted() {
        if (this.$store.state.user) {
            this.$router.push("/mypage/tickets");
        }
        this.useHead({
            title: "お問い合わせ | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>